<template>
  <donut-form-item
    :label="copy.label"
    :description="copy.description"
    :left-align="true"
  >
    <template v-if="hasPairingPreferencesName" #description>
      Add anyone you'd rather not be paired with (optional). <strong>This list is completely confidential.</strong> Pairing preferences only apply to channels where Donut creates groups of 2 (excluding <a href="https://help.donut.ai/en/articles/3024637-intro-types" target="_blank" class="link">Lottery Intros</a>).
    </template>
    <div class="f-v">
      <donut-selex-users
        v-model="selectedUsers"
        :placeholder="copy.placeholder"
        :loading="loading"
        :multiple="true"
        value-key="uid"
        :update-action="(value) => handleUsersSelected(value)"
      />
    </div>
  </donut-form-item>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

const { state, dispatch, getters } = useStore();

const incompatiblePairs = computed(() => getters['incompatiblePairs/incompatiblePairs']);
const loading = computed(() => getters['incompatiblePairs/loading']);

const hasPairingPreferencesName = computed(() => getters['incompatiblePairs/hasPairingPreferencesName']);
const copy = computed(() => (hasPairingPreferencesName.value
  ? {
    label: 'Pairing preferences',
    placeholder: 'Select teammates',
  }
  : {
    label: "Don't pair me with...",
    description: "Select teammates you do not want to be paired with (optional). This applies to any Donut Intros channel you're in and channels where Donut creates groups of 2 (excluding Lottery Intros). Avoiding teammates is completely confidential.",
    placeholder: 'Select teammates to avoid',
  }));

const selectedUsers = computed({
  get: () => incompatiblePairs.value.map(pair => pair.invalid_partner),
  set: (value) => {
    // Do nothing - we handle changes via update-action
  },
});

onMounted(() => {
  dispatch('incompatiblePairs/fetchIncompatiblePairs', state.currentUser.id);
});

const handleUsersSelected = (selectedUserUids) => {
  window.mixpanel.track('User Web Settings - Avoid Pairing - Users Selected', {
    count: selectedUserUids.length,
  });
  dispatch('incompatiblePairs/bulkUpdateIncompatiblePairs', {
    userId: state.currentUser.id,
    invalidPartnerUids: selectedUserUids,
  });
};
</script>
